module.exports = __webpack_public_path__ + "static/media/mango.a81346b6.png";